import React from "react";
import ContactForm from "./ContactForm";
import SocialLinks from "./SocialLinks";

const ContactGrid = () => {
  return (
    <section className="relative w-full overflow-x-hidden bg-white">
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-40 -right-40 h-[34rem] w-[34rem] rounded-full bg-[color:var(--brand-accent)]/10 blur-3xl" />
        <div className="absolute -bottom-52 -left-52 h-[38rem] w-[38rem] rounded-full bg-[color:var(--brand)]/10 blur-3xl" />
      </div>

      <div className="relative mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 py-18 sm:py-20">
        <div className="grid w-full gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5 w-full min-w-0">
            <div className="w-full min-w-0 rounded-2xl border border-[color:var(--border)] bg-[color:var(--surface)] p-8">
              <div className="text-sm font-semibold text-[color:var(--brand)]">
                Connect
              </div>
              <div className="mt-3 text-2xl font-semibold text-[color:var(--navy)]">
                Stay in touch
              </div>
              <p className="mt-3 text-sm text-[color:var(--muted)] leading-relaxed">
                Follow our updates and insights on quality systems, training, and operational excellence.
              </p>

              <div className="mt-7 w-full min-w-0">
                <SocialLinks
                  instagramUrl="https://instagram.com/"
                  linkedinUrl="https://linkedin.com/"
                  youtubeUrl="https://youtube.com/"
                />
              </div>

              <div className="mt-10 w-full min-w-0 rounded-xl border border-[color:var(--border)] bg-white p-6">
                <div className="text-sm font-semibold text-[color:var(--navy)]">
                  Typical response time
                </div>
                <div className="mt-2 text-sm text-[color:var(--muted)]">
                  Within 1–2 business days
                </div>

                <div className="mt-6 grid gap-3">
                  <div className="flex items-center gap-2 text-sm text-[color:var(--navy)]/85">
                    <span className="h-2 w-2 rounded-full bg-[color:var(--brand-accent)]" />
                    Discovery call scheduling
                  </div>
                  <div className="flex items-center gap-2 text-sm text-[color:var(--navy)]/85">
                    <span className="h-2 w-2 rounded-full bg-[color:var(--brand-accent)]" />
                    Service recommendation
                  </div>
                  <div className="flex items-center gap-2 text-sm text-[color:var(--navy)]/85">
                    <span className="h-2 w-2 rounded-full bg-[color:var(--brand-accent)]" />
                    Clear next steps
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 w-full min-w-0">
            <div className="w-full min-w-0">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactGrid;
